export const BestValueBadge = () => (
  <span data-testid="best-value-badge"
    className="inline-block border border-emerald-200 dark:border-emerald-500/30 bg-emerald-50 dark:bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 px-1.5 py-0.5 text-[9px] uppercase tracking-[0.12em] font-bold">
    Best
  </span>
);
